import ApiService from './ApiService'
import Vue from 'vue'

export const LeadsWebService = {
  baseURL: `${process.env.VUE_APP_LEADS_WEB_URL}/v1`,

  getLeadFlows () {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/lead-flows`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  getLeadFlowStatesByLeadFlowId (leadFlowId) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/lead-flows/${leadFlowId}/states`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  getLeads (data = {}) {
    let config = {
      params: data.params
    }
    return new Promise((resolve, reject) => {
      return Vue.axios.get(`${this.baseURL}/leads`, config)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  getLeadById (id) {
    return new Promise((resolve, reject) => {
      return Vue.axios.get(`${this.baseURL}/leads/${id}`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  getFlowById( id) {
    return new Promise((resolve, reject) => {
      return Vue.axios.get(`${this.baseURL}/flows/${id}`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  getFlows() {
    return new Promise((resolve, reject) => {
      return Vue.axios.get(`${this.baseURL}/flows/minified`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  getContactActions (flowId, withFullDetails = false) {
    let url = ''
    if (withFullDetails) {
      url = `${this.baseURL}/contact-actions/flow/${flowId}?full=true`
    } else {
      url = `${this.baseURL}/contact-actions/flow/${flowId}`
    }

    return new Promise((resolve, reject) => {
      return Vue.axios.get(url)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
    /* ApiService.query(`${this.baseURL}/contact-actions`, config)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    }) */
  },

  getLeadContactsByLeadId (leadId) {
    return new Promise((resolve, reject) => {
      return Vue.axios.get(`${this.baseURL}/lead-contacts/${leadId}`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  update (resource, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/leads/${resource}`, params)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  getLeadSuppliers () {
    return new Promise((resolve, reject) => {
      return Vue.axios.get(`${this.baseURL}/suppliers`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  getLeadSources () {
    return new Promise((resolve, reject) => {
      return Vue.axios.get(`${this.baseURL}/lead-sources`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  getLeadClientIds () {
    return new Promise((resolve, reject) => {
      return Vue.axios.get(`${this.baseURL}/lead-clients`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  runManualAction (leadId, actionId, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/leads/${leadId}/run-action/${actionId}`, params)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  getLeadObservations (leadId) {
    return new Promise((resolve, reject) => {
      return Vue.axios.get(`${this.baseURL}/lead-observations/${leadId}`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  createLeadObservation (params) {
    return new Promise((resolve, reject) => {
      return ApiService.post(`${this.baseURL}/lead-observations`, params)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  getLeadStatuses () {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/leads/statuses`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

}
